import ConversationsHotkeysFooter from 'src/pages/landlord/conversations/components/hotkeys/ConversationsHotkeys';
export default ConversationsHotkeysFooter;
